<template>
  <div class="row">
    <div
      v-bind:records="records"
      v-for="record in records"
      :key="record.id"
      class="col-6"
    >
      <div class="tile tile--center u-no-padding">
        <div class="tile__container">
          <div class="row">
            <div class="col-9 ignore-screen">
              <div class="tile__title">
                <div>{{ record.candidate.full_name }}</div>
              </div>
              <div class="tile__subtitle">
                {{ record.task_name }}
              </div>
              <div class="info">
                <div class="tag-container u-no-margin">
                  <status-tag
                    v-bind:status="record.status"
                    v-bind:label="record.result"
                  >
                  </status-tag>
                  <record-repeat-icon v-bind:isRepeat="record.is_repeat">
                  </record-repeat-icon>
                </div>
              </div>
            </div>
            <div class="col-3 ignore-screen --list-table-action-button">
              <record-action-button
                v-bind:record="record"
              ></record-action-button>
            </div>
            <div class="col-12">
              <div class="info">
                <div v-if="record.instructor">
                  <span>With {{ record.instructor }}</span>
                  <span v-if="record.date">
                    on {{ formatDate(record.date) }}
                  </span>
                  <span v-if="record.aircraft_identifier">
                    in {{ record.aircraft_identifier }} ({{
                      record.aircraft_type
                    }})
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { DateFormatter } from "@/functions/dateFormat.function";
import RecordActionButton from "@/components/records/RecordActionButton";
import RecordRepeatIcon from "@/components/records/RecordRepeatIcon";
import StatusTag from "@/components/StatusTag";

export default {
  name: "record-list",
  components: {
    RecordRepeatIcon,
    RecordActionButton,
    StatusTag
  },
  props: {
    error: {},
    records: Array
  },
  methods: {
    formatDate: function(dateString) {
      var result = DateFormatter(dateString);
      return result;
    }
  }
};
</script>
